import config from '../../config/config';

interface RequestOptions extends RequestInit {
  params?: Record<string, string>;
}

class ApiClient {
  private baseUrl: string;

  constructor() {
    this.baseUrl = config.API_URL;
  }

  private async request<T>(endpoint: string, options: RequestOptions = {}): Promise<T> {
    const { params, ...requestOptions } = options;
    
    let url = `${this.baseUrl}${endpoint}`;
    if (params) {
        const searchParams = new URLSearchParams(params);
        url += `?${searchParams.toString()}`;
    }

    try {
        const response = await fetch(url, {
            ...requestOptions,
            headers: {
                // Only set Content-Type if not using FormData
                ...(requestOptions.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
                ...requestOptions.headers,
            },
        });

        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        

        const data = await response.json();
        return data as T;
    } catch (error) {
        console.error('API request failed:', error);
        throw error;
        }
    }

    public get<T>(endpoint: string, options: RequestOptions = {}) {
        return this.request<T>(endpoint, { ...options, method: 'GET' });
    }

    public post<T>(endpoint: string, data: unknown, options: RequestOptions = {}) {
        // Check if data is FormData, if so, do not stringify it
        const body = data instanceof FormData ? data : JSON.stringify(data);

        return this.request<T>(endpoint, {
            ...options,
            method: 'POST',
            body,
        });
    }
}

export const apiClient = new ApiClient(); 